import { Left } from 'fp-ts/lib/Either'
import { pipe } from 'fp-ts/lib/function'
import { Errors } from 'io-ts'
import { withDecoder } from '../../../utils/withDecoder'
import { selfMeCodec } from './codec'

export const meDecoder = (payload: unknown) => pipe(payload, withDecoder(selfMeCodec))

export type SelfMe = Exclude<ReturnType<typeof meDecoder>, Left<Errors>>['right']
